export const AGE_VERIFICATION = 'AGE_VERIFICATION'
export const EMOJIS = 'EMOJIS'
export const GALLERY_ALBUM_IMAGE = 'GALLERY_ALBUM_IMAGE'
export const HIDE_FLOATING_PLAYER = 'HIDE_FLOATING_PLAYER'
export const MENU = 'MENU'
export const QUICKBUY = 'QUICKBUY'
export const RULE_VIOLATION = 'RULE_VIOLATION'
export const WHITEBOARD = 'WHITEBOARD'
